<script lang="ts">
  import { appStore } from "$app/store.svelte"
</script>

<div class="mt-8 relative max-w-7xl mx-auto">
  <div class="mx-auto flex justify-center bg-white shadow-lg flex-wrap">
    <div
      class="border border-gray-100 shadow-sm rounded-sm bg-white p-2 w-1/2 lg:w-2/12"
    >
      <div class="text-sm font-bold text-center">Brand Purpose</div>
      {#if appStore.plan_review.brand_purpose}
        <img
          src={appStore.plan_review.brand_purpose.symbol_url}
          class="w-20 h-20 rounded-full mx-auto mt-4"
          alt={appStore.plan_review.brand_purpose.name}
        />
        <div class="text-sm text-center mt-4">
          {appStore.plan_review.brand_purpose.name}
        </div>
      {:else}
        <div class="text-sm text-center mt-4 italic">No Brand Purpose</div>
      {/if}
    </div>
    <div
      class="border border-gray-100 shadow-sm rounded-sm bg-white p-2 w-1/2 lg:w-2/12"
    >
      <div class="text-sm font-bold text-center">Blue Sky Vision</div>
      {#if appStore.plan_review.blue_sky}
        <img
          src={appStore.plan_review.blue_sky.symbol_url}
          class="w-20 h-20 rounded-full mx-auto mt-4"
          alt={appStore.plan_review.blue_sky.name}
        />
        <div class="text-sm text-center mt-4">
          {appStore.plan_review.blue_sky.name}
        </div>
      {:else}
        <div class="text-sm text-center mt-4 italic">No Blue Sky Vision</div>
      {/if}
    </div>

    <div
      class="border border-gray-100 shadow-sm rounded-sm bg-white p-2 w-full lg:w-8/12"
    >
      <div class="text-sm font-bold text-center">Values</div>
      <div class="flex justify-around">
        {#each appStore.plan_review.values as value}
          <div class="mx-2">
            <img
              src={value.symbol_url}
              class="w-20 h-20 rounded-full mx-auto mt-4"
              alt={value.name}
            />
            <div class="text-sm text-center mt-4">
              {value.name}
            </div>
          </div>
        {:else}
          <div class="text-sm text-center mt-4 italic">No Values</div>
        {/each}
      </div>
    </div>
  </div>
</div>
